<template>
<!-- 咨询报告 -->
  <div v-if="bodyShow" class="xd_consult_report">
      <img class="bg" src="https://themes-cdn.xjy.cn/statics/career/images/xuandui_gadgets/ConReport-bg.png" alt="">
      <div class="title">咨询报告</div>
      <!--  -->
      <div class="main">
          <div v-for="(item,index) in list" :key="index">
            <div v-for="(child,idx) in item" :key="idx" class="list">
                <div class="r-title">
                    <div class="bdl"></div>
                    {{child.label}}
                </div>
                <div class="content">
                    {{child.value}}
                </div>
            </div>
          </div>
      </div>
  </div>
</template>

<script>
import { shareCon } from "@/utils/wxconfig";
import { deepCopy,setSessionStorage,getSessionStorage } from "@/utils/tools";
import { counsellingGet,userInfo } from "@/api/xuandui_gadgets"
export default {
    data(){
        return{
            bodyShow:false,
            list:[[
                {
                    label:'咨询主题',
                    value:'暂无更多信息'
                }
            ]]
        }
    },
    methods:{
        // 初始化获取数据
        pullData(){
             //调用加载中
            this.$emit('loadingHandle',true,"拼命加载中...");
            let q = this.$route.query;
            if(!q.oid){
                this.$toast('订单ID不能为空');
                return
            }
            counsellingGet({
                id:q.oid
            }).then((data)=>{
                    //关闭加载中
                this.$emit('loadingHandle',false);
                if(data.error>0){
                    this.$toast(data.msg);
                    return
                }
                document.title = '咨询报告';
                if(data.item.report && JSON.parse(data.item.report)){
                    this.list = JSON.parse(data.item.report);
                }
                this.bodyShow = true;
            });
            
        }
    },
    created(){
        this.pullData();
    }
}
</script>
<style lang="scss">
    body{
        background-color: #ffffff;
    }
</style>
<style lang="scss" scoped>
.xd_consult_report{
    position: relative;
    .bg{
        width: 100%;
        height: 432px;
    }
    .title{
        position: absolute;
        top: 126px;
        left: 80px;
        font-size: 36px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #FFFFFF;
        line-height: 50px;
    }
    .main{
        position: relative;
        z-index: 2;
        margin-top: -72px;
        padding: 72px 30px  30px;
        background: #FFFFFF;
        border-radius: 60px 60px 0px 0px;
        .list{
            display: flex;
            flex-direction: column;
            margin-bottom: 30px;
            &:last-of-type{
                margin-bottom: 0;
            }
            .r-title{
                height: 98px;
                display: flex;
                align-items: center;
                font-size: 32px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #2B333A;
                line-height: 46px;
                .bdl{
                    width: 6px;
                    height: 30px;
                    background: #46A3FA;
                    border-radius: 6px;
                    margin-right: 20px;
                }
            }
            .content{
                background: #F7F8F9;
                border-radius: 20px;
                padding: 36px 30px 30px;
                font-size: 28px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #7D8289;
                line-height: 46px;
            }
        }
    }
}
</style>